import { List, Map as ImmutableMap } from 'immutable';
import { isCustomBehavioralEventObjectTypeId } from 'customer-data-filters-ui/filterQueryFormat/ObjectTypeId';
import Adapter from './Adapter';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
const parseOptions = options => {
  return options.reduce((acc, option) => {
    if (!option.hidden) {
      return acc.push(PropertyOptionRecord({
        label: option.label,
        value: option.value
      }));
    }
    return acc;
  }, List());
};
export class CustomBehavioralEventPropertiesAdapterConfig extends HttpAdapterConfig {
  getCacheKey(eventTypeId) {
    return `EVENT_PROPERTIES_${eventTypeId}`;
  }
  isAssetFamilySupported(assetFamily) {
    return isCustomBehavioralEventObjectTypeId(assetFamily);
  }
  fetchData(httpClient, eventTypeId) {
    return httpClient(`properties/v4/${eventTypeId}`);
  }
  formatData(customBehavioralEventProperties) {
    return customBehavioralEventProperties.reduce((acc, customBehavioralEventProperty) => {
      const {
        property: {
          label,
          name,
          options,
          type,
          externalOptions,
          externalOptionsReferenceType
        }
      } = customBehavioralEventProperty;
      return acc.set(name, DSFieldRecord(Object.assign({
        label,
        type,
        name,
        options: parseOptions(options)
      }, externalOptions && {
        externalOptions
      }, externalOptionsReferenceType && {
        externalOptionsReferenceType
      })));
    }, ImmutableMap());
  }
}
export default Adapter.makeFromConfig(CustomBehavioralEventPropertiesAdapterConfig);